import React, { useState, useEffect, useMemo } from "react";
import styled from "styled-components";
import { debounce } from "lodash";
import {
  SearchFilterContainer,
  SearchFilterProvider,
  SearchFilterGroup,
  SearchFilterOption,
} from "../library/SearchFilter";
import CandidateListSelectedFilters from "./CandidateListSelectedFilters";
import { FilterData } from "../CandidatesListPage";

const CandidateListFilterBar = (props: Props) => {
  const { initialQuery, onQueryChange, onFiltersChange, filters } = props;
  const [query, setQuery] = useState(initialQuery);

  const debouncedQueryChange = useMemo(
    () => debounce(onQueryChange, 350),
    [onQueryChange]
  );

  useEffect(() => {
    debouncedQueryChange.cancel();
    debouncedQueryChange(query);
  }, [query, debouncedQueryChange]);

  return (
    <SearchFilterProvider initialValue={filters} onChange={onFiltersChange}>
      <SearchBar>
        <SearchInput
          placeholder="Search for a candidate"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
        />

        <SearchFilterContainer>
          <SearchFilterGroup
            label="Application status"
            defaultCollapsed={false}
          >
            <SearchFilterOption name="status" value="awaiting_feedback">
              Awaiting feedback
            </SearchFilterOption>
            <SearchFilterOption name="status" value="interviewing">
              Interviewing
            </SearchFilterOption>
            <SearchFilterOption name="status" value="rejected">
              Rejected
            </SearchFilterOption>
          </SearchFilterGroup>
        </SearchFilterContainer>
      </SearchBar>

      <CandidateListSelectedFilters filters={filters} />
    </SearchFilterProvider>
  );
};

const SearchInput = styled.input`
  flex: 1;
  padding: 0.5rem 1rem;
  border-radius: 3px;
  margin-right: 1rem;
  border: 1px solid ${({ theme }) => theme.colors.gray700};
`;

const SearchBar = styled.div`
  display: flex;
  border-radius: 3px;
  margin-bottom: 1rem;
`;

type Props = {
  initialQuery?: string;
  onQueryChange: (query: string) => void;
  onFiltersChange: (filters: FilterData) => void;
  filters: FilterData;
};

export default CandidateListFilterBar;
